
import { oz } from '@weft/utils';
import { TRIAL_DURATION_TYPES } from './trial-duration-types';

export const TrialDurationSchema = oz.object({
  duration: oz.number(),
  type: oz.nativeEnum(TRIAL_DURATION_TYPES),
  free: oz.boolean().default(false),
}).openapi('PlanTrial');

export type PlanTrial = oz.infer<typeof TrialDurationSchema>;